'use strict'

import Swiper from "swiper"
import {Navigation, Pagination} from "swiper/modules"

import {mainForm} from "../scripts/components/Form.js"


const officeSiblingsGallerySelector = '[data-swiper="border-box-gallery"]'
new Swiper(officeSiblingsGallerySelector, {
  modules: [Navigation, Pagination],
  spaceBetween: 16,

  breakpoints: {
    320: {slidesPerView: 1.25},
    576: {slidesPerView: 1.5},
    768: {slidesPerView: 1.75},
    992: {slidesPerView: 2.5},
    1200: {slidesPerView: 2.75},
    1400: {slidesPerView: 3}
  },

  pagination: {
    el: `${officeSiblingsGallerySelector} + .row .swiper-pagination`,
    type: 'progressbar'
  },

  navigation: {
    nextEl: `${officeSiblingsGallerySelector} + .row .swiper-button-next`,
    prevEl: `${officeSiblingsGallerySelector} + .row .swiper-button-prev`
  }
})

const applyForm = document.querySelector('form.apply-form')
if (applyForm) new mainForm(applyForm)

